import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildTableFilterQueryOpts from '@/shared/tablefilter/filters';

import { IPortalInfo } from '@/shared/model/portal-info.model';

const baseApiUrl = 'api/portal-infos';

export default class PortalInfoService {
  public find(id: number): Promise<IPortalInfo> {
    return new Promise<IPortalInfo>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      // pagination and sorting
      let queryParameter = buildPaginationQueryOpts(paginationQuery);
      if (queryParameter.length > 0) {
        queryParameter += '&';
      }
      // filtering
      queryParameter += buildTableFilterQueryOpts(paginationQuery);

      axios
        .get(baseApiUrl + `?${queryParameter}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}
